<mat-divider></mat-divider>
<footer>
    &copy; All rights reserved 2020
</footer>